"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Link;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@umich-lib/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var StyledLink = ( /*#__PURE__*/0, _styledBase["default"])('a', {
  target: "e2b8o640",
  label: "StyledLink"
})(function (props) {
  return _styles.LINK_STYLES[props.kind];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPbUIiLCJmaWxlIjoiLi4vc3JjL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHtcbiAgTElOS19TVFlMRVNcbn0gZnJvbSAnQHVtaWNoLWxpYi9zdHlsZXMnXG5cbmNvbnN0IFN0eWxlZExpbmsgPSBzdHlsZWQoJ2EnKShwcm9wcyA9PiBMSU5LX1NUWUxFU1twcm9wcy5raW5kXSlcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gTGluayh7IGNoaWxkcmVuLCAuLi5vdGhlciB9KSB7XG4gIHJldHVybiAoXG4gICAgPFN0eWxlZExpbmsgey4uLm90aGVyfT5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L1N0eWxlZExpbms+XG4gIClcbn1cblxuTGluay5wcm9wVHlwZXMgPSB7XG4gIGtpbmQ6IFByb3BUeXBlcy5vbmVPZihbXG4gICAgXCJkZWZhdWx0XCIsXG4gICAgXCJzdWJ0bGVcIixcbiAgICBcImxpZ2h0XCIsXG4gICAgXCJzcGVjaWFsXCIsXG4gICAgXCJsaXN0XCIsXG4gICAgXCJsaXN0LW1lZGl1bVwiLFxuICAgIFwibGlzdC1zdHJvbmdcIixcbiAgICBcImRlc2NyaXB0aW9uXCJcbiAgXSksXG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMubm9kZS5pc1JlcXVpcmVkLFxuICBhczogUHJvcFR5cGVzLm5vZGUsXG59O1xuXG5MaW5rLmRlZmF1bHRQcm9wcyA9IHtcbiAga2luZDogJ2RlZmF1bHQnLFxuICBhczogJ2EnXG59OyJdfQ== */");

function Link(_ref) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, ["children"]);

  return (0, _core.jsx)(StyledLink, other, children);
}

Link.propTypes = {
  kind: _propTypes["default"].oneOf(["default", "subtle", "light", "special", "list", "list-medium", "list-strong", "description"]),
  children: _propTypes["default"].node.isRequired,
  as: _propTypes["default"].node
};
Link.defaultProps = {
  kind: 'default',
  as: 'a'
};